import * as React from "react";
import { cx } from "../internal/cx.js";
import { DashboardLayout, type DashboardLayoutProps } from "./dashboard-layout.js";

export interface EducationLayoutProps extends Omit<DashboardLayoutProps, "width"> {
  /** Optional table-of-contents or related-links rail. */
  aside?: React.ReactNode;
  /** Optional hero/summary region above the article body. */
  hero?: React.ReactNode;
}

/**
 * Long-form reading shell. Wraps `DashboardLayout` with an article + aside
 * grid for guides, education content, and support pages.
 */
export const EducationLayout = React.forwardRef<HTMLDivElement, EducationLayoutProps>(
  function EducationLayout({ aside, children, className, hero, ...props }, ref) {
    return (
      <DashboardLayout
        ref={ref}
        className={cx("cw-v2-education-layout", className)}
        width="wide"
        {...props}
      >
        {hero ? <div className="cw-v2-education-layout__hero">{hero}</div> : null}
        <div className="cw-v2-education-layout__body">
          <article className="cw-v2-education-layout__article">{children}</article>
          {aside ? <aside className="cw-v2-education-layout__aside">{aside}</aside> : null}
        </div>
      </DashboardLayout>
    );
  },
);
EducationLayout.displayName = "EducationLayout";
